import { GtmEvent } from "../events";
import {
  isoTimestamp,
  safeString,
  stripUndefined,
  safeBoolean,
} from "../utils";

const deriveUserId = (stakeholder) =>
  safeString(
    stakeholder?.localAccountId ||
      stakeholder?.accountId ||
      stakeholder?.id ||
      stakeholder?.code ||
      stakeholder?.username,
  );

const deriveAccountCode = ({ customer, stakeholder, persistedCustomerId }) => {
  if (customer?.code) {
    return safeString(customer.code);
  }

  if (stakeholder?.customerCode) {
    return safeString(stakeholder.customerCode);
  }

  return safeString(persistedCustomerId);
};

export const buildUserContext = ({
  stakeholder,
  customer,
  persistedCustomerId,
  persistedAgentId,
}) => {
  if (!stakeholder) {
    return undefined;
  }

  const userId = deriveUserId(stakeholder);
  const account = deriveAccountCode({
    customer,
    stakeholder,
    persistedCustomerId,
  });

  const context = stripUndefined({
    userId,
    account,
    role: safeString(stakeholder?.role),
    stakeholderId: safeString(stakeholder?.id),
    agentId: safeString(stakeholder?.agentId || persistedAgentId),
    customerId: safeString(customer?.id || persistedCustomerId),
    isCustomerCare: safeBoolean(stakeholder?.role?.includes?.("CustomerCare")),
  });

  if (!context.userId && !context.account) {
    return undefined;
  }

  return context;
};

export const buildUserSessionEvent = ({
  stakeholder,
  customer,
  timestamp,
  persistedCustomerId,
  persistedAgentId,
}) => {
  const context = buildUserContext({
    stakeholder,
    customer,
    persistedCustomerId,
    persistedAgentId,
  });

  if (!context) {
    return undefined;
  }

  // Usa context.account (customer.code) per coerenza con tutti gli altri eventi GTM
  // (prima usava context.userId che è l'ID interno dello stakeholder → discrepanza)
  const account = context.account || context.userId;

  if (!account) {
    return undefined;
  }

  return stripUndefined({
    event: GtmEvent.USER_SESSION_START,
    account,
    role: context.role,
    loginTime: isoTimestamp(timestamp),
  });
};
